import { useCallback } from "react";
import { graphql, useMutation } from "react-relay";
import { useSetFocusScrollMutation } from "./__generated__/useSetFocusScrollMutation.graphql";

export const useSetScrollFocusMutation = (
  storecastId: string | undefined,
  widgetId: string
) => {
  const [setScroll] = useMutation<useSetFocusScrollMutation>(graphql`
    mutation useSetFocusScrollMutation(
      $topItemId: ID!
      $storecastId: ID!
      $widgetId: ID!
    ) {
      dashboard(dashboardId: $storecastId) {
        setFocusScroll(topItemId: $topItemId, widgetId: $widgetId)
      }
    }
  `);
  const cb = useCallback(
    (topItemId: string) => {
      if (!storecastId || !topItemId) {
        return;
      }
      setScroll({
        variables: {
          topItemId,
          widgetId,
          storecastId,
        },
      });
    },
    [setScroll, storecastId, widgetId]
  );

  return cb;
};
